import { Cart } from '../types/cart'
import { Check, Payment, PaymentStatus } from '../types/orders'
import { getCheckTotal } from './cart-helpers'

export const calculatePartialPaymentAmount = (
  cart: Cart | undefined,
  percentage: number
): number => {
  if (!cart || percentage <= 0 || percentage > 1) {
    return 0
  }

  const total = getCheckTotal(cart)

  // Convert to cents to avoid floating point precision errors
  const totalCents = Math.round(total * 100)
  const partialCents = totalCents * percentage

  // Round to nearest cent using standard rounding (round half up)
  const roundedCents = Math.round(partialCents)

  // Convert back to dollars
  return roundedCents / 100
}

const paymentCountsTowardsBalance = (payment: Payment): boolean => {
  return !(
    payment.paymentStatus === PaymentStatus.DENIED ||
    payment.paymentStatus === PaymentStatus.ERROR ||
    payment.paymentStatus === PaymentStatus.ERROR_NETWORK ||
    payment.paymentStatus === PaymentStatus.PROCESSING_VOID ||
    payment.paymentStatus === PaymentStatus.VOIDED ||
    payment.paymentStatus === PaymentStatus.VOIDED_AT_RISK ||
    payment.paymentStatus === PaymentStatus.CANCELLED ||
    payment.paymentStatus === PaymentStatus.PROCESSING
  )
}

export const getTotalAmountPaid = (check?: Check | null): number => {
  if (!check) return 0

  let totalPaid = 0
  check.payments.forEach((payment) => {
    if (paymentCountsTowardsBalance(payment)) {
      const paymentCents = Math.round((payment.amount ?? 0) * 100)
      const paymentTipCents = Math.round((payment.tipAmount ?? 0) * 100)
      totalPaid += paymentCents + paymentTipCents
    }
  })

  return totalPaid / 100
}

export const getAmountDue = (check: Check, amountToPay?: number): number => {
  // Convert to cents to avoid floating point precision errors
  const totalAmountCents = Math.round(check.totalAmount * 100)

  if (amountToPay) {
    const amountToPayCents = Math.round(amountToPay * 100)
    return (totalAmountCents - amountToPayCents) / 100
  }

  const totalPaidCents = Math.round(getTotalAmountPaid(check) * 100)
  return (totalAmountCents - totalPaidCents) / 100
}
